<div>
  <div class="d-flex justify-content-between dialog-title">
    <div>
      <p class="mb-0 mt-1 dialog-title">Select Order Type</p>
    </div>
    <div>
      <!--      <button [mat-dialog-close]="true" mat-icon-button>-->
      <!--        <mat-icon class="dialog-icon">close</mat-icon>-->
    <!--      </button>-->
  </div>
</div>
<hr>
  <div mat-dialog-content>
    <nz-radio-group [(ngModel)]="orderType">
      <label nz-radio nzValue="1">Dine In</label>
      <label nz-radio nzValue="2">Take Away</label>
      <label nz-radio nzValue="3">Delivery</label>
      <label nz-radio nzValue="3">Function</label>
    </nz-radio-group>
    <nz-form-item>
      <div class="w-100">
        <nz-form-label>Customer Name</nz-form-label>
        <nz-form-control>
          <input nz-input [(ngModel)]="customerName" placeHolder="Enter customer name">
        </nz-form-control>
      </div>
    </nz-form-item>
    <nz-form-item>
      <div class="w-100">
        <nz-form-label>Customer Phone</nz-form-label>
        <nz-form-control>
          <input nz-input [(ngModel)]="customerPhone" placeHolder="Enter customer phone"/>
        </nz-form-control>
      </div>
    </nz-form-item>
  </div>
  <div class="mt-3 d-flex justify-content-end mb-4 me-4 ms-4">
    <!-- <button class="w-25 btn-radius me-2" [mat-dialog-close]="true" nzType="primary" nzGhost nz-button>
    Cancel
  </button> -->
  <button nzType="primary" nz-button class="w-100 btn-radius" (click)="onSelectOrderType()">Confirm</button>


</div>
</div>
